import "./works.scss"
import { useState } from "react"

export default function Works() {
    const [currentSlide,setCurrentSlide]=useState(0)
    const data=[
        {
            id:1,
            icon:"assets/phone.png",
            title:"Web Design",
            info:"project (1)",
            desc:"Define your future today.",
            img:"assets/work.png"
        },
        {
            id:2,
            icon:"assets/setting.jpg",
            title:"Privacy",
            info:"project (2)",
            desc:"To live is to Dare.",
            img:"assets/workaa.jpg"
        },
        {
            id:3,
            icon:"assets/business.jpg",
            title:"Online Trading",
            info:"project (3)",
            desc:"Business is all we need.",
            img:"assets/workab.jpg"
        }
    ]
    const handleClick=(way)=>{
        way === "left" ? setCurrentSlide(currentSlide > 0 ? currentSlide-1 : 2) :
        setCurrentSlide(currentSlide<data.length -1 ?currentSlide+1 : 0 )
    }
    return (
        <div className="works" id="works">
<div className="slider" style={{transform:`translateX(-${currentSlide*100}vw)`}}>
                {data.map((d,ki)=>(
                <div className="container" key={ki}>
                    <div className="item">
                        <div className="left">
                            <div className="leftContainer">
                                <div className="imgContainer">
                                    <img src={d.icon} alt=""/>
                                </div>
                                <h2>{d.title}</h2>
                                <p>
                               {d.desc}
                                </p>
                                <span>{d.info}</span>
                            </div>
                        </div>
                        <div className="right">
                            <img src={d.img} alt=""/>
                        </div>
                    </div>
                </div>
                   ))}
            </div>
         <img src="assets/leftarrow.png" alt="" 
         className="arrow left" onClick={()=>handleClick("left")} />
         <img src="assets/rightarrow.png" 
         alt="" className="arrow right" onClick={()=>handleClick("right")} />
        </div>
    )
}
